const SHOP_INVOICES = "SHOP_INVOICES";
const SHOP_INVOICES_SUCCESS = "SHOP_INVOICES_SUCCESS";
const SHOP_INVOICES_FAILURE = "SHOP_INVOICES_FAILURE";
const CLEAR_SHOP_INVOICES = "CLEAR_SHOP_INVOICES";

const ShopInvoicesSymbols = {
  SHOP_INVOICES_SUCCESS,
  SHOP_INVOICES_FAILURE,
  SHOP_INVOICES,
  CLEAR_SHOP_INVOICES,
};
export default ShopInvoicesSymbols;
